import {css} from 'glamor'
import PropTypes from 'prop-types'
import {default as React} from 'react'
import {default as Container} from 'react-bootstrap/lib/Grid'
import Row from 'react-bootstrap/lib/Row'
import {default as PrepButton} from '../button'
import Icon, {icons} from '../icon'
import Input from '../input'

const style = {
  form: {
    emailInput: css({
      paddingTop: '7px',
      paddingBottom: '14px'
    }),
    submit: css({
      paddingTop: '7px',
      paddingBottom: '7px'
    })
  },
  right: css({
    float: 'right',
    width: '10%'
  }),
  left: css({
    float: 'left',
    width: '90%'
  })
}

const propTypes = {
  errors: PropTypes.shape({
    email: PropTypes.string
  }),
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onFocus: PropTypes.func,
  status: PropTypes.shape({
    success: PropTypes.bool
  }),
  touched: PropTypes.shape({
    email: PropTypes.bool
  }),
  values: PropTypes.shape({
    email: PropTypes.string
  }),
  hideModalCallback: PropTypes.func.isRequired
}

const DesktopContent = ({
  handleChange,
  handleBlur,
  onFocus,
  touched,
  errors,
  values,
  isSubmitting
}) => {
  return (
    <Container fluid className="hidden-xs">
      <Row {...style.form.emailInput}>
        <Input
          compact
          autoComplete="email"
          label="Email address"
          name="email"
          onBlur={handleBlur}
          onChange={handleChange}
          onFocus={onFocus}
          size="block"
          type="email"
          required
          valid={touched.email ? !errors.email : undefined}
          value={values.email}
        />
      </Row>
      <Row>
        {touched.email && errors.email && (
          <div className="error-message" {...style.errorMessage}>
            {errors.email}
          </div>
        )}
      </Row>
      <Row>
        <PrepButton block disabled={isSubmitting} size="small" type="submit">
          <span>Submit</span>
        </PrepButton>
      </Row>
    </Container>
  )
}

DesktopContent.propTypes = propTypes

const MobileContent = ({
  handleChange,
  handleBlur,
  onFocus,
  touched,
  errors,
  values,
  isSubmitting
}) => {
  return (
    <div className="visible-xs">
      <div {...style.left}>
        <Input
          compact
          autoComplete="email"
          label="Email address"
          name="email"
          onBlur={handleBlur}
          onChange={handleChange}
          onFocus={onFocus}
          size="block"
          type="email"
          required
          valid={touched.email ? !errors.email : undefined}
          value={values.email}
        />

        {touched.email && errors.email && (
          <div className="error-message" {...style.errorMessage}>
            {errors.email}
          </div>
        )}
      </div>

      <div {...style.right}>
        <PrepButton block disabled={isSubmitting} size="small" type="submit">
          <span>
            <Icon icon={icons.chevronRight} />
          </span>
        </PrepButton>
      </div>
    </div>
  )
}

MobileContent.propTypes = propTypes

const PromoEmailSignupFormContent = props => {
  return (
    <>
      <MobileContent {...props} />
      <DesktopContent {...props} />
    </>
  )
}

export default PromoEmailSignupFormContent
